import 'services/i18'

import AuthorStoryPromptScreen from 'assets/images/tour/Author_4_StoryPrompt.png'
import AuthorEditStoryScreen from 'assets/images/tour/Author_5_EditStoryIcon.png'
import GuestStoryPromptScreen from 'assets/images/tour/Guest_3_StoryPrompt.png'
import GuestWriteStoryScreen from 'assets/images/tour/Guest_4_WriteStory.png'
import GuestReadStoryScreen from 'assets/images/tour/Guest_5_ReadStory.png'
import MobileEditStoryScreen from 'assets/images/tour/Mobile_5_EditStory.png'
import PurchaserPendingPromptsScreen from 'assets/images/tour/Purchaser_5_PendingPromptsAndReorder.png'
import PurchaserPromptOptionsScreen from 'assets/images/tour/Purchaser_6_StoryPromptOptions.png'
import PurchaserEditStoryScreen from 'assets/images/tour/Purchaser_7_EditStoryIcon.png'
import ReaderStoryPromptScreen from 'assets/images/tour/Reader_3_StoryPrompt.png'
import i18n from 'services/i18'
import { breakpoints, colors } from 'style'
import styled from 'styled-components'

export const ScreenshotContainer = styled.img`
  object-fit: contain;
  margin-top: 1rem;
  margin-bottom: 2rem;
  max-height: 66vh;
  border: 1px solid ${colors.black};

  @media (max-width: ${breakpoints.md}px) {
    margin-bottom: 1rem;
    max-height: 50vh;
  }
`
export const StepContainer = styled.div`
  display: flex;
  flex-direction: column;

  p {
    margin-right: 1rem;
    margin-left: 1rem;

    @media (max-width: ${breakpoints.md}px) {
      font-size: 12px;
    }
  }

  &.screenshot-wrapper {
    height: 85vh;

    @media (max-width: ${breakpoints.md}px) {
      height: 66vh;
    }
  }
`

const mobileStyles = {
  popover: (base) => ({
    ...base,
    top: '0px',
  }),
}

const getStepsForRole = (bookRole, isMobile = false, navigateRouter) => {
  const finishedSection = {
    selector: '.dashboard-wrapper',

    content: (
      <StepContainer>
        <p>{`${i18n.t('tour_finished_1')}`}</p>
        <p>{`${i18n.t('tour_finished_2')}`} </p>
        <p>
          <a href="https://help.anecdobio.com">https://help.anecdobio.com</a>
        </p>
      </StepContainer>
    ),
  }

  if (isMobile) {
    return [
      {
        selector: '.mobile-icons',
        content: (
          <StepContainer>
            <p>{`${i18n.t('tour_intro')}`}</p>
          </StepContainer>
        ),
        styles: mobileStyles,
      },
      {
        selector: '#info-icon-mob',
        content: (
          <StepContainer>
            <p>{`${i18n.t('tour_book_info_overview_mobile')}`}</p>
          </StepContainer>
        ),
        styles: mobileStyles,
      },
      {
        selector: '#friends-icon-mob',
        content: (
          <StepContainer>
            <p>{`${i18n.t('tour_friends')}`}</p>
          </StepContainer>
        ),
        styles: mobileStyles,
      },
      {
        selector: '#stories-icon-mob',
        content: (
          <StepContainer>
            <p>{`${i18n.t('tour_stories_mobile')}`}</p>
          </StepContainer>
        ),
        styles: mobileStyles,
      },
      {
        selector: '#stories-icon-mob',
        content: (
          <StepContainer className="screenshot-wrapper">
            <ScreenshotContainer src={MobileEditStoryScreen} />
            <p>{`${i18n.t('tour_edit_story_mobile')}`}</p>
          </StepContainer>
        ),
        styles: mobileStyles,
      },
      {
        ...finishedSection,
        styles: mobileStyles,
      },
    ]
  }

  const purchaserEditorSteps = [
    {
      selector: '.dashboard-nav',
      action: () => {
        navigateRouter('/info/overview')
      },
      content: (
        <StepContainer>
          <p>{`${i18n.t('tour_intro')}`}</p>
        </StepContainer>
      ),
    },
    {
      selector: '.dashboard-wrapper',
      action: () => {
        navigateRouter('/info/overview')
      },
      content: (
        <StepContainer>
          <p>{`${i18n.t('tour_book_info_overview')}`}</p>
        </StepContainer>
      ),
    },
    {
      selector: '.dashboard-wrapper',
      action: () => {
        navigateRouter('/friends')
      },
      content: (
        <StepContainer>
          <p>{`${i18n.t('tour_friends')}`}</p>
        </StepContainer>
      ),
    },
    {
      selector: '#add-user-btn',
      action: () => {
        navigateRouter('/friends')
      },
      content: (
        <StepContainer>
          <p>{`${i18n.t('tour_purchaser_add_contributor')}`}</p>
        </StepContainer>
      ),
    },
    {
      selector: '.dashboard-wrapper',
      action: () => {
        navigateRouter('/stories')
      },
      content: (
        <StepContainer>
          <p>{`${i18n.t('tour_story_section')}`}</p>
        </StepContainer>
      ),
    },
    {
      selector: '#prompt-catalog-link',
      content: (
        <StepContainer>
          <p>{`${i18n.t('tour_purchaser_add_prompt')}`}</p>
        </StepContainer>
      ),
    },
    {
      selector: '.dashboard-wrapper',
      content: (
        <StepContainer className="screenshot-wrapper">
          <ScreenshotContainer src={PurchaserPendingPromptsScreen} />
          <p>{`${i18n.t('tour_purchaser_story_prompts')}`}</p>
        </StepContainer>
      ),
    },
    {
      selector: '.dashboard-wrapper',
      content: (
        <StepContainer className="screenshot-wrapper">
          <ScreenshotContainer src={PurchaserPromptOptionsScreen} />
          <p>{`${i18n.t('tour_expand_prompt')}`}</p>
        </StepContainer>
      ),
    },
    {
      selector: '.dashboard-wrapper',
      action: () => {
        navigateRouter('/stories')
      },
      content: (
        <StepContainer className="screenshot-wrapper">
          <ScreenshotContainer src={PurchaserEditStoryScreen} />
          <p>{`${i18n.t('tour_purchaser_edit_story')}`}</p>
        </StepContainer>
      ),
    },
    finishedSection,
  ]

  const guestSteps = [
    {
      selector: '.dashboard-wrapper',
      action: () => {
        navigateRouter('/info/overview')
      },
      content: (
        <StepContainer>
          <p>{`${i18n.t('tour_intro')}`}</p>
        </StepContainer>
      ),
    },
    {
      selector: '.dashboard-wrapper',
      content: (
        <StepContainer>
          <p>{`${i18n.t('tour_book_info_overview_reader_guest')}`}</p>
        </StepContainer>
      ),
    },
    {
      selector: '.dashboard-wrapper',
      content: (
        <StepContainer className="screenshot-wrapper">
          <ScreenshotContainer src={GuestStoryPromptScreen} />
          <p>{`${i18n.t('tour_guest_story_1')}`}</p>
          <p>{`${i18n.t('tour_guest_story_2')}`}</p>
        </StepContainer>
      ),
    },
    {
      selector: '.dashboard-wrapper',
      content: (
        <StepContainer className="screenshot-wrapper">
          <ScreenshotContainer src={GuestWriteStoryScreen} />
          <p>{`${i18n.t('tour_guest_story_write')}`}</p>
        </StepContainer>
      ),
    },
    {
      selector: '.dashboard-wrapper',
      content: (
        <StepContainer className="screenshot-wrapper">
          <ScreenshotContainer src={GuestReadStoryScreen} />
          <p>{`${i18n.t('tour_guest_story_read')}`}</p>
        </StepContainer>
      ),
    },
    finishedSection,
  ]

  const authorSteps = [
    {
      selector: '.dashboard-wrapper',
      action: () => {
        navigateRouter('/info/overview')
      },
      content: (
        <StepContainer>
          <p>{`${i18n.t('tour_intro')}`}</p>
        </StepContainer>
      ),
    },
    {
      selector: '.dashboard-wrapper',
      action: () => {
        navigateRouter('/info/overview')
      },
      content: (
        <StepContainer>
          <p>{`${i18n.t('tour_book_info_overview')}`}</p>
        </StepContainer>
      ),
    },
    {
      selector: '.dashboard-wrapper',
      action: () => {
        navigateRouter('/friends')
      },
      content: (
        <StepContainer>
          <p>{`${i18n.t('tour_friends')}`}</p>
        </StepContainer>
      ),
    },
    {
      selector: '#add-user-btn',
      action: () => {
        navigateRouter('/friends')
      },
      content: (
        <StepContainer>
          <p>{`${i18n.t('tour_author_add_reader')}`}</p>
        </StepContainer>
      ),
    },
    {
      selector: '.dashboard-wrapper',
      action: () => {
        navigateRouter('/stories')
      },
      content: (
        <StepContainer className="screenshot-wrapper">
          <ScreenshotContainer src={AuthorStoryPromptScreen} />
          <p>{`${i18n.t('tour_author_story_prompts')}`}</p>
        </StepContainer>
      ),
    },
    {
      selector: '.dashboard-wrapper',
      content: (
        <StepContainer className="screenshot-wrapper">
          <ScreenshotContainer src={AuthorEditStoryScreen} />
          <p>{`${i18n.t('tour_author_edit_story_1')}`}</p>
          <p>{`${i18n.t('tour_author_edit_story_2')}`}</p>
        </StepContainer>
      ),
    },
    finishedSection,
  ]

  const readerSteps = [
    {
      selector: '.dashboard-wrapper',
      action: () => {
        navigateRouter('/info/overview')
      },
      content: (
        <StepContainer>
          <p>{`${i18n.t('tour_intro')}`}</p>
        </StepContainer>
      ),
    },
    {
      selector: '.dashboard-wrapper',
      action: () => {
        navigateRouter('/info/overview')
      },
      content: (
        <StepContainer>
          <p>{`${i18n.t('tour_book_info_overview_reader_guest')}`}</p>
        </StepContainer>
      ),
    },
    {
      selector: '.dashboard-wrapper',
      action: () => {
        navigateRouter('/stories')
      },
      content: (
        <StepContainer className="screenshot-wrapper">
          <ScreenshotContainer src={ReaderStoryPromptScreen} />
          <p>{`${i18n.t('tour_reader_new_story')}`}</p>
        </StepContainer>
      ),
    },
    finishedSection,
  ]

  const steps = {
    author: authorSteps,
    reader: readerSteps,
    guest: guestSteps,
    purchaser: purchaserEditorSteps,
    editor: purchaserEditorSteps,
    none: [],
  }

  return steps[bookRole.toLowerCase() || 'none']
}

export { getStepsForRole }
